import React from "react";
import PageHeader from "../../../components/common/PageHeader";

/**
 * Takeaway Header Component
 * Displays the page header with title and subtitle
 */
const TakeawayHeader = () => {
  return (
    <PageHeader
      showBackButton={true}
      backTo={-1}
      title="Takeaway Orders"
      subtitle={
        <span className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 bg-green-500 rounded-full"></span>
          Create and manage takeaway orders
        </span>
      }
    />
  );
};

export default TakeawayHeader;
